import { defineMessages } from 'react-intl';

export default defineMessages({
    returningToWInsurance: {
        id: 'quoteandbind.common.controllers.ESignatureCallbackCtrl.Returning to W-Insurance.com...',
        defaultMessage: 'Returning to W-Insurance.com...',
    }
});